export const RouteConstants = {
  WILDCARD: "*",
  BASE: "/",
  CONFIG: "/config",
  SLIM: "/slim",
  STIKE_ZONE: "/strikezone",
  WHITE: "/white",
  LIGHT: "/light",
  DARK: "/dark",
};
